import { httpRequest } from './httpRequest';
import { SESSION_STORAGE_ACCOUNT_KEY, SESSION_STORAGE_CLIENTINFO_KEY } from './sessionStorage'
const covrServicesUrl = window.__ENV__.REACT_APP_COVR_SERVICES_URL

async function saveSessionEvent() {
  let pathname = window && window.location && window.location.pathname

  let account = JSON.parse(sessionStorage.getItem(SESSION_STORAGE_ACCOUNT_KEY));

  let sessionLogExtraParams = '';

  if (window.location.href.includes("DataImport")) {
    var clientInfoObj = sessionStorage.getItem(SESSION_STORAGE_CLIENTINFO_KEY);
    if (clientInfoObj) {
      let clientInfo = JSON.stringify(JSON.parse(clientInfoObj).value);
      sessionLogExtraParams = `&DataImport=${clientInfo}`;
    }
  }

  if (account !== null) {
    let sessionId = account.value.sessionId;
   
    const x = httpRequest.get(`${covrServicesUrl}/api/Session?SessionId=${sessionId}&Pathname=${pathname}` + sessionLogExtraParams)
    return x
  }
}

export { saveSessionEvent }




// WEBPACK FOOTER //
// ./src/session.js